(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-ny-size-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-ny-size-grid')) {
    customElements.define('image-ny-size-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest('.product-section');
        this.select = this.querySelector('[data-variant-input]');
        this.variants = JSON.parse(this.querySelector('[data-size-variants]').textContent);
        this.buttons = [...this.querySelectorAll('[data-size]')];
        const collator = new Intl.Collator(document.documentElement.lang, { numeric: true });
        if (this.buttons.every(button => /^\d/.test(button.dataset.size))) {
          this.buttons.sort((a, b) => collator.compare(a.dataset.size, b.dataset.size));
          this.buttons.forEach(button => this.querySelector('.image-ny-size-grid__choices').append(button));
        }
        this.onChange = () => this.refresh();
        this.section.addEventListener('variantChange', this.onChange);
        this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button)));
        this.refresh();
      }
      disconnectedCallback() {
        this.section?.removeEventListener('variantChange', this.onChange);
        this.initialized = false;
      }
      variantFor(size) {
        const options = {};
        this.section.querySelectorAll('[data-variant-input]').forEach(input => {
          if (input.type !== 'radio' || input.checked) options[input.dataset.index] = input.value;
        });
        options['option' + this.dataset.position] = size;
        return this.variants.find(variant => Object.entries(options).every(([key, value]) => variant[key] === value));
      }
      refresh() {
        this.buttons.forEach(button => {
          const variant = this.variantFor(button.dataset.size);
          const state = !variant ? 'nonexistent' : variant.available ? 'available' : 'sold-out';
          button.dataset.availability = state;
          button.disabled = !variant?.available;
          button.hidden = !variant?.available;
          button.setAttribute('aria-pressed', String(this.select.value === button.dataset.size));
          const label = !variant ? this.dataset.nonexistentLabel : variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
          button.setAttribute('aria-label', button.dataset.size + ' — ' + label);
        });
        this.querySelector('.image-ny-size-grid__heading').hidden = this.buttons.every(button => button.hidden);
        const selected = this.variantFor(this.select.value);
        const form = document.getElementById(this.dataset.formId);
        const payment = form?.querySelector('.shopify-payment-button');
        if (payment) payment.hidden = !selected?.available;
      }
      choose(button) {
        const variant = this.variantFor(button.dataset.size);
        if (!variant?.available) return;
        this.select.value = button.dataset.size;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.refresh();
      }

    });
  }
  } catch(e) { console.error(e); }
})();

})();
